module.exports = __webpack_public_path__ + "static/img/dl_linkedin.0574b2a4.png";